import { createContext } from 'react';

import type TournamentService from 'services/tournament/tournamentService';
import TournamentServiceImpl from 'services/tournament/tournamentServiceImpl';

// TODO: injectable services - by vuk_niko
// Tournament service context
export const TournamentServiceContext = createContext<TournamentService>(new TournamentServiceImpl());
